<template>
  <div class="dialog-review-rules">
    <div class="wrap-form">
      <Form :model="reviewData" :label-width="120" ref="editForm" :rules="validateRules">
        <FormItem label="评阅规则：" prop="auditPlanId">
          <RadioGroup v-model="reviewData.auditPlanId">
            <Radio :label="item.id" v-for="(item, index) in rulesList" :key="index">{{item.auditPlanName}}</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>
    <Spin size="large" fix v-if="dialogLoading"></Spin>
  </div>
</template>

<script>
export default {
  name: 'relatedReview',
  props: {
    query: ''
  },
  data () {
    return {
      dialogLoading: true,
      paperInfoIds: '',
      reviewData: {
        auditPlanId: ''
      },
      rulesList: [],
      validateRules: {
        auditPlanId: [{required: true, message: '评阅规则不能为空', trigger: 'blur'}]
      }
    };
  },
  created () {
    this.paperInfoIds = this.query
    let paperIds = this.query.split(',')
    this.fetchRulesList();
    if (this.query && paperIds.length > 0) {
      this.fetReviewData()
    }
  },
  methods: {
    fetReviewData () {
      this.fetch(`school/schoolAuditPlanConfig/getSchoolAuditPlanConfigByPaperInfoId/${this.paperInfoIds}`).then(res => {
        this.reviewData.auditPlanId = res.data.id
      })
    },
    fetchRulesList () {
      const _self = this;
      _self.dialogLoading = true;
      _self.post('/school/schoolAuditPlanConfig/schoolAuitPlanConfigListBySchoolId')
        .then(res => {
          _self.dialogLoading = false;
          _self.rulesList = res.data;
        })
        .catch(() => {
          _self.dialogLoading = false;
        });
    },
    // 确定回调事件
    dialogComfirm () {
      return new Promise((resolve, reject) => {
        const _self = this;
        _self.$refs['editForm'].validate((valid) => {
          if (valid) {
            _self.post('/school/schoolAuditPlanConfig/updatePaperInfoAuditPlan', {
              selectIds: _self.paperInfoIds.split(',').map(item => item),
              schoolAuditPlanId: _self.reviewData.auditPlanId
            }).then(res => {
              _self.$Message.success(res.msg);
              resolve(res);
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-review-rules {
}
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/thesisManage/relevanceReviewRules.vue